export * from '@igetcool/base-components';
export * from './validate';

export const IGETUSER = 'IGetCool-USER-Info';
export const GOODSINFO = 'GOODS_INFO';


export const ISession = (key, value) => {
  if (value) {
    return sessionStorage.setItem(key, value);
  }
  return sessionStorage.getItem(key);
};

export const ILocalStorage = (key, value) => {
  if (value) {
    return localStorage.setItem(key, value);
  }
  return localStorage.getItem(key);
};


export const add = (a, b) => {
  var c, d, e;
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {
    d = 0;
  }
  e = Math.pow(10, Math.max(c, d));
  return (mul(a, e) + mul(b, e)) / e;
};

export const sub = (a, b) => {
  var c, d, e;
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {
    d = 0;
  }
  e = Math.pow(10, Math.max(c, d));
  return (mul(a, e) - mul(b, e)) / e;
};

export const mul = (a, b) => {
  var c = 0,
    d = a.toString(),
    e = b.toString();
  try {
    c += d.split('.')[1].length;
  } catch (f) {
  }
  try {
    c += e.split('.')[1].length;
  } catch (f) {
  }
  return Number(d.replace('.', '')) * Number(e.replace('.', '')) / Math.pow(10, c);
};

export function formatDate(date, fmt, iosIOS) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
  }
  if (iosIOS) {
    let str = new Date(date).valueOf();
    str -= 60 * 60 * 8 * 1000;
    date = new Date(str);
  }

  let o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + '';
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : padLeftZero(str));
    }
  }
  return fmt;
}

// 将时间转化为00:00
export function formatDuring(during, cFormat) {
  !during && (during = 0);
  during = parseInt(during);
  let hours = parseInt(during / 3600);
  let minutes = parseInt(during / 60) % 60;
  let seconds = parseInt(during % 60);

  let format = cFormat || '{h}:{m}:{s}';
  if (hours <= 0) {
    const index = format.indexOf('{m}');
    format = format.slice(index);
  }
  const formatObj = {
    h: hours,
    m: minutes,
    s: seconds,
  };

  return format.replace(/{([hms])+}/g, (result, key) => {
    const value = formatObj[key];
    return value ? value.toString().padStart(2, '0') : '00';
  });
}



function padLeftZero(str) {
  return ('00' + str).substr(str.length);
}

export const getQueryStr = (query, start = '?') => {
  let result = start;
  for (let key in query) {
    result += `${key}=${query[key]}&`;
  }
  result = result.substr(0, result.length - 1);
};

// 查询某个字符串出现特定字符多少次
export const getCharCount = (str, char) => {
  var regex = new RegExp(char, 'g'); // 使用g表示整个字符串都要匹配
  var result = str.match(regex);          // match方法可在字符串内检索指定的值，或找到一个或多个正则表达式的匹配。
  var count = !result ? 0 : result.length;
  return count;
};

/**
 *
 * @param time 毫秒级时间差（非时间戳）
 * @returns {string[]} 返回倒计时 天 时 分 秒
 * @author 刘洋
 */
export function leftTime2HMS(time) {
  time = time / 1000;
  let d = Math.floor(time / (60 * 60 * 24));
  let h = Math.floor((time - d * 60 * 60 * 24) / (60 * 60));
  let m = Math.floor((time - d * 60 * 60 * 24 - h * 60 * 60) / 60);
  let s = Math.floor((time - d * 60 * 60 * 24 - h * 60 * 60 - m * 60));
  let leftTime = [d, h, m, s];
  return leftTime.map(item => {
    if (item === 0) {
      return item;
    }
    return item.toString().padStart(2, '0');
  });
}

export function formatDateYMD(date) {

  // console.log(typeof date);
  if (typeof date !== 'object') {
    date = new date(date);
  }
  let month = date.getMonth() + 1 + '';
  let day = date.getDate() + '';
  let year = date.getFullYear();
  return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
}

// 替换指定传入参数的值,paramName为参数,replaceWith为新值
export function replaceParamVal(url, paramName, replaceWith) {
  let oUrl = url;
  let re = eval('/(' + paramName + '=)([^&]*)/gi');
  let nUrl = oUrl.replace(re, paramName + '=' + replaceWith);
  return nUrl;
}
// 判断地址中是否有相应字段
export function resetParamVal(url, paramName, replaceWith = '') {
  url && (url = decodeURIComponent(url));
  if (url.indexOf('?') > -1) {
    if (url.includes(paramName)) {
      url = replaceParamVal(url, paramName, replaceWith);
    } else {
      url += `&${paramName}=${replaceWith}`;
    }
  } else {
    url += `?${paramName}=${replaceWith}`;
  }
  return url;
}

// 生成唯一标识uuid,abtest使用
export function abUuid() {
  let now = new Date().getTime();
  let str = `mall-xxxxxxxx-xxxx-${now}`;
  let ranid = str.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0,
      v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
  return ranid.split('-').join('');
}

// 判断是否在抖音APP内
export function isDouyinApp() {
  // 判断抖音版本号
  const APP_VERSION_REGX = {
    android: new RegExp('app_version/', 'i'),
    ios: new RegExp('aweme_', 'i')
  };
  const ua = navigator.userAgent;
  const os = /(Android);?\s+([\d.]+)?/i.test(ua) ? 'android' : 'ios';
  const version = parseFloat(ua.split(APP_VERSION_REGX[os])[1]);

  if (version.toString() !== 'NaN') {
    return true;
  } else {
    return false;
  }
}

// 获取地址栏对应字段
export function getUrlQuery(name) {
  const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  const r = window.location.search.substr(1).match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

// 判断当前H5页面是否在小程序中
export function isInMiniprogram() {
  return new Promise((resolve) => {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      // ios的ua中无miniProgram，但都有MicroMessenger（表示是微信浏览器）
      wx.miniProgram.getEnv((res) => {
        if (res.miniprogram) {
          resolve(true);
        } else {
          resolve(false);
        }
      });
    } else {
      resolve(false);
    }
  });
}

// 判断当前是否在百度浏览器中
// Mozilla/5.0 (Linux; Android 12; NTH-AN00 Build/HONORNTH-AN00; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/97.0.4692.98 Mobile Safari/537.36 T7/13.23 light/1.0 SP-engine/2.61.0 baiduboxapp/13.23.0.11 (Baidu; P1 12)
export function isInBaidu() {
  const ua = navigator.userAgent.toLowerCase();
  if (ua.indexOf('baiduboxapp') !== -1) {
    return true;
  } else {
    return false;
  }
}

// 判断当前是否在安卓浏览器中
export function isAndroidWebview() {
  var u = navigator.userAgent;
  let isAndroidWebview  = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  return isAndroidWebview;
}
